// material-ui
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import React, { Component } from "react";
// styles
import styles from "./styles";

class Link extends Component {
  static propTypes = {
    classes: PropTypes.object,
    children: PropTypes.any,
    href: PropTypes.string,
  };

  render() {
    const { children, classes, href } = this.props;

    return (
      <a
        className={classes.link}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "inherit", textDecoration: "underline" }}
      >
        {children}
      </a>
    );
  }
}

export default withStyles(styles)(Link);
